import React, {ReactNode} from 'react';

export interface HeaderProps {
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
  children?: ReactNode;
}

function Header({left, right, className = '', children}: HeaderProps) {
  return (
    <header className={`header ${className}`}>
      <div className="inner">
        <div className="nav nav_center">
          <div className="nav_box">{left}</div>
          {children}
          <div className="nav_box">{right}</div>
        </div>
      </div>
    </header>
  );
}

export default Header;
